module.exports = __webpack_public_path__ + "static/img/zhuanli-1.0080220d.png";